'use client';

import useForkRef from '@mui/utils/useForkRef';
export default useForkRef;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/useForkRef.js
// module id = 33
// module chunks = 22